import { useRef, useEffect } from 'react';

interface ProjectRenameInputProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

// Input field for renaming a project in the workspace page
export const ProjectRenameInput = ({
  value,
  onChange,
  onSubmit,
  onCancel,
  isLoading = false,
}: ProjectRenameInputProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') onSubmit();
    else if (e.key === 'Escape') onCancel();
  };

  return (
    <input
      ref={inputRef}
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={handleKeyDown}
      onBlur={onSubmit}
      disabled={isLoading}
      className={`
        w-full min-w-0 border-b-2 border-gray-300 transition-all duration-200
        ease-in-out outline-none
        hover:border-gray-400
        focus:border-yellow-500
      `}
    />
  );
};
